export default __webpack_public_path__ + "static/media/Needles of Bone and Horn.3120affe.jpg";